"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guardianInvitePersonaFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const persona_1 = require("../../../../mocks/persona");
exports.guardianInvitePersonaFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    uuid: Factory.each(() => uuid_1.v4()),
    name: persona_1.persona.full_name,
});
